<script setup>
const props = defineProps({
  error: {
    type: Object,
    default: null,
  },
});

/* eslint-disable no-console */
console.error(props.error);

const router = useRouter();
const { t } = useI18n();

const goBack = () => {
  router.go(-1);
};

const goToDashboard = () => {
  router.push('/');
};

function getErrorDescription(code) {
  const descriptions = {
    404: t('errors.error_404.description'),
    500: t('errors.error_500.description'),
    default: t('errors.error_default.description'),
  };
  return descriptions[code] || descriptions.default;
}

// Set color mode to light
useHead({
  htmlAttrs: {
    class: 'light',
  },
});
</script>
<template>
  <div
    class="container d-flex flex-column justify-content-center align-items-center min-vh-100 py-3 py-md-5"
  >
    <div class="error-image-container mb-3 mb-md-4">
      <img
        src="/salesupply-logo.svg"
        :alt="$t('common.images.error')"
        class="error-image img-fluid"
      />
    </div>

    <div class="col-12 col-md-8 col-lg-6 text-center">
      <h2 class="error-status-code">
        {{ error?.statusCode }}
      </h2>
      <p class="error-status-message mb-2">
        {{ error.statusMessage }}
      </p>
      <p class="error-description mb-4">
        {{ getErrorDescription(error?.statusCode) }}
      </p>
      <div
        class="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2 gap-md-3"
      >
        <PortalButton class="btn-primary" @button-action="goBack">
          {{ $t('errors.buttons.go_back') }}
        </PortalButton>
        <PortalButton class="btn-success" @button-action="goToDashboard">
          {{ $t('errors.buttons.go_to_dashboard') }}
        </PortalButton>
      </div>
    </div>
  </div>
</template>
<style scoped>
.error-stack {
  font-size: 0.75rem;
  overflow-x: auto;
  white-space: pre-wrap;
  max-height: 200px;
  text-align: left;
  background: #f8f8f8;
  padding: 1rem;
  border-radius: 4px;
}

.error-image {
  max-width: 100%;
  height: auto;
  max-height: 180px;
  transition: transform 0.3s ease;
}

.error-image-container {
  margin-bottom: 1.5rem;
}

.error-status-code {
  font-size: clamp(5rem, 20vw, 12rem);
  line-height: 1;
  font-weight: bold;
  margin-bottom: 0.25em;
  background: #189ee7;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.error-status-message {
  font-size: clamp(1.25rem, 4vw, 1.75rem);
  color: var(--bs-muted);
  font-weight: 500;
}

.error-description {
  font-size: 1rem;
  color: var(--bs-secondary);
  max-width: 500px;
  margin: 0 auto;
}

.container {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);
  max-width: 800px;
  margin: 0 auto;
}
</style>
